
export enum MetricName {
    ActivePatients = "ACTIVE_PATIENTS",
    ActiveBoarding = "ACTIVE_BOARDING",
    ArrivalToDeparture = "ARRIVAL_TO_DEPARTURE",
    ActiveLOS = "ACTIVE_LOS",
    ArrivalToRoom = "ARRIVAL_TO_ROOM",
    ActiveWaiting = "ACTIVE_WAITING",
    BoardingTime = "BOARDING_TIME",
    ActiveBoardingTime = "ACTIVE_BOARDING_TIME",
    ArrivalToDispo = "ARRIVAL_TO_DISPO",
    RoomToDispo = "ROOM_TO_DISPO",
    ActiveInRoomTime = "ACTIVE_IN_ROOM_TIME",
    ActualArrived = "ACTUAL_ARRIVED",
    ActualRoomed = "ACTUAL_ROOMED",
    ActualBoarded = "ACTUAL_BOARDED",
    ActualDispo = "ACTUAL_DISPO",
    ActualDeparted = "ACTUAL_DEPARTED",
    ActiveAdmitRisk = "ACTIVE_ADMIT_RISK",
    ActualAdmitRiskTP = "ACTUAL_ADMIT_RISK_TP_COUNT",
    ActualAdmitRiskFP = "ACTUAL_ADMIT_RISK_FP_COUNT",
    ActualAdmitRiskAUROC = "ACTUAL_ADMIT_RISK_AUROC",
    ActualForecastPatientsMAE = "ACTUAL_FORECAST_PATIENTS_MAE",
    ActiveBoardingMAE = "ACTIVE_BOARDING_MAE",
    ActiveBedRequestsMAE = "ACTIVE_BED_REQUESTS_MAE",
    ActiveRoomedNotDispoMAE = "ACTIVE_ROOMED_NOT_DISPO_MAE",
    RevisitScoreAUROC = "REVISIT_SCORE_AUROC",
}

export enum CurrentRelativeMetricName {
    Patient = "PATIENTS",
    BoardedPatients = "BOARDED_PATIENTS",
    LengthOfStay = "LENGTH_OF_STAY",
    BoardingTime = "BOARDING_TIME",
}

export const METRIC_NAME_TO_DISPLAY: any = {
    [MetricName.ActivePatients]: "# of Patients",
    [MetricName.ArrivalToDeparture]: "Arrival to Departure (hours)",
    [MetricName.ActiveLOS]: "Length of Stay (hours)",
    [MetricName.ArrivalToRoom]: "Arrival to Room (hours)",
    [MetricName.ActiveWaiting]: "Rooming Time (hours)",
    [MetricName.BoardingTime]: "Boarding Time (hours)",
    [MetricName.ActiveBoardingTime]: "Boarding Time (hours)",
    [MetricName.ArrivalToDispo]: "Arrival to Dispo (hours)",
    [MetricName.RoomToDispo]: "Room to Dispo (hours)",
    [MetricName.ActiveInRoomTime]: "In Room Time (hours)",
    [MetricName.ActiveAdmitRisk]: "# of Patients Likely to Board",

    [MetricName.ActualArrived]: "# Arrived",
    [MetricName.ActualRoomed]: "# Roomed",
    [MetricName.ActualDispo]: "# Dispo",
    [MetricName.ActualBoarded]: "# Bed Requests",
    [MetricName.ActualDeparted]: "# Departed",
    [MetricName.ActualAdmitRiskTP]: "# of Admit Risk True Positives",
    [MetricName.ActualAdmitRiskFP]: "# of Admit Risk False Positives",
    [MetricName.ActualAdmitRiskAUROC]: "Admit Risk Model AUROC",
    [MetricName.ActualForecastPatientsMAE]: "MAE of the # of Patients",
    [MetricName.ActiveBedRequestsMAE]: "MAE of the # of Bed Requests",
    [MetricName.ActiveBoardingMAE]: "MAE of the # of Patients Boarded",
    [MetricName.ActiveRoomedNotDispoMAE]: "MAE of the # of Roomed Not Dispo Patients",
    [MetricName.RevisitScoreAUROC]: "Revisit Score AUROC",
}

export const METRIC_NAME_TO_DESCRIPTION: any = {
    [MetricName.ActivePatients]: "Number of patients in the ED captured every 15 min",
    [MetricName.ArrivalToDeparture]: "The median duration of stay (hours), recorded at the time of the patient's departure from the ED",
    [MetricName.ActiveLOS]: "The median duration of stay (hours) of patients currently in the ED, captured every 15 min",
    [MetricName.ArrivalToRoom]: "The median time it took for patients to be roomed (hours), recorded at the time of patient rooming in the ED",
    [MetricName.ActiveWaiting]: "The median time patients are waiting in the ED (hours), captured every 15 min",
    [MetricName.BoardingTime]: "The median boarding time (hours), recorded at the time of the patient's departure from the ED",
    [MetricName.ActiveBoardingTime]: "The median time patients are boarded in the ED (hours), captured every 15 min",
    [MetricName.ArrivalToDispo]: "The median arrival to departure (hours), recorded at the time when the patient's dispo status changed in the ED",
    [MetricName.RoomToDispo]: "The median time room to dispo time (hours), recorded at the time when the patient's dispo status changed in the ED",
    [MetricName.ActiveInRoomTime]: "The median time patients are spending in a room in the ED (hours), captured every 15 min",
    [MetricName.ActiveAdmitRisk]: "Number of patients in the ED who are likely to be admitted in the ED, captured every 15 min",

    [MetricName.ActualArrived]: "Number of patients in the ED who arrived, recorded at the time of patient's arrival",
    [MetricName.ActualRoomed]: "Number of patients in the ED who were roomed, recorded at the time of patient's rooming",
    [MetricName.ActualDispo]: "Number of patients in the ED who were dispo'd, recorded at the time of patient's dispo status change",
    [MetricName.ActualBoarded]: "Number of patients in the ED who were boarded, recorded at the time of patient's boarding",
    [MetricName.ActualDeparted]: "Number of patients in the ED who departed, recorded at the time of patient's departure",
    [MetricName.ActualAdmitRiskTP]: "Number of patients in the ED who were predicted to board, and actually boarded",
    [MetricName.ActualAdmitRiskFP]: "Number of patients in the ED who were predicted to board, but did not actually board",
    [MetricName.ActualAdmitRiskAUROC]: "AUROC of the admit risk model based on the past 30-day patients",
    [MetricName.RevisitScoreAUROC]: "AUROC of the 30-day revisit score model based on patients departed 30 days ago",
    [MetricName.ActualForecastPatientsMAE]: "Mean absolute error of the number of patients in the ED",
    [MetricName.ActiveBedRequestsMAE]: "Mean absolute error of the number of inpatient admit orders that occur each hour",
    [MetricName.ActiveBoardingMAE]: "Mean absolute error of the number of boarders",
    [MetricName.ActiveRoomedNotDispoMAE]: "Mean absolute error of the number of active patients",
}

export enum PlotType {
    TimeTrends = "TimeTrends",
    HourOfDay = "HourOfDay",
    DayOfWeek = "DayOfWeek",
}

export enum PlotScope {
    PointInTime = "PointInTime",
    Actuals = "Actuals",
}

export const METRICS_DIMENSION_OPTIONS = [
    {
        "name": "No Grouping",
        "id": "ALL",
    },
    {
        "name": "Age",
        "id": "AGE",
    },
    {
        "name": "Gender",
        "id": "GENDER",
    },
    {
        "name": "Admit Service",
        "id": "ADMIT_SERVICE",
    },
    {
        "name": "Zone",
        "id": "ZONE",
    },
    {
        "name": "Disposition",
        "id": "DISPOSITION_STATUS",
    },
    {
        "name": "Acuity",
        "id": "TRIAGE_ACUITY",
    },
    {
        "name": "Census",
        "id": "CENSUS",
    },
];

export const METRICS_PERIOD_OPTIONS = [
    {
        "name": "15 min",
        "id": "15m",
    },
    {
        "name": "Hourly",
        "id": "1h",
    },
    {
        "name": "4 Hours",
        "id": "4h",
    },
    {
        "name": "Daily",
        "id": "1d",
    },
];

export const METRICS_FORECAST_HORIZON_OPTIONS = [
    {
        "name": "1 Hour",
        "id": "0h",
    },
    {
        "name": "6 Hours",
        "id": "6h",
    },
    {
        "name": "12 Hours",
        "id": "12h",
    },
    {
        "name": "18 Hours",
        "id": "18h",
    },
    {
        "name": "24 Hours",
        "id": "24h",
    },
];

export const METRICS_DIMENSION_VALUES: any = {
    "AGE": ["<5", "5-17", "18-44", "45-64", ">=65"],
    "ADMIT_SERVICE": ["Adolescent Medicine", "Anesthesiology", "Bone Marrow Transplant", "Cardiac Surgery", "Cardiology", "Cardiology Arrhythmia", "Cardiology Congenital", "Cardiology Interventional", "Cardiology Transplant", "Cardiovascular ICU", "Cardiovascular Medicine", "Cath-Angio", "Critical Care", "Cystic Fibrosis Adult", "Dentistry", "Emergency", "Emergency Critical Care", "Emergency Medicine", "Endocrinology", "ENT", "Gastroenterology", "General Medicine (PAMF)", "General Medicine (T)", "General Medicine (University)", "General Surgery", "Geriatric Psychiatry", "GI/Liver", "Gynecology", "Gyn-Oncology", "Hand Surgery", "Hematology", "Hematology/Oncology", "Hepatology", "Hospice", "ICU Trauma/GenSurg", "Integrative Medicine", "Interventional Radiology", "Kidney & Kidney/Pancreas", "Liver Transplant", "LPCH Obstetric Overflow", "Medicine", "Nephrology", "Neurocritical Care", "Neurology", "Neurology/Stroke Svc", "Neurosurgery", "No Admit Service", "Obstetrics", "Oncology", "Ophthalmology", "Orthopaedic Surgery", "Outpatient Surgery at Redwood City", "Pain Management", "Palliative Care", "Pediatric Nephrology", "Pediatrics", "Plastic Surgery", "Psychiatry", "Psych Oncology", "Pulmonary", "Pulmonary Hypertension", "Pulmonary Transplant", "Radiology", "Rheumatology", "Service Needed", "Speech Language Pathology", "Spinal Surgery", "Thoracic Surgery", "Transplant Donor Net", "Transplant Surgery", "Trauma", "Urology", "Vascular Surgery"],
    "CENSUS": ["ADMIT_BOARDING", "CONDITIONAL", "DISCHARGE", "ELOPEMENT", "OBSERVATION", "ROOMED", "UNKNOWN", "WAITING"],
    "DISPOSITION_STATUS": ["Admit Inpt", "AMA", "Arr in Error", "Conditional", "Deci to Admi", "Discharge", "Elopement", "Expired", "Inpatient", "LWBS", "Obs-CDU", "Observation", "Place in Obs", "Place in OP", "Send L", "TranLPCH/PEC", "Transfer", "Transfer-Psy", "VCED LWBS"],
    "GENDER": ["F", "M", ""],
    "TRIAGE_ACUITY": ["1-Resuscitation", "2-Emergent", "3-Urgent", "4-Semi-Urgent", "5-Non-Urgent", "Unknown", ""],
    "ZONE": ["ADULT_ED_OVRFLW", "ALPHA", "ALPHA_HALLWAY", "BRAVO", "BRAVO_HALLWAY", "CARDINAL", "CARDINAL_HALLWAY", "DELTA", "DELTA_HALLWAY", "EMERALD", "FOXTROT", "FOXTROT_HALLWAY", "HOLDING_BAY", "LOBBY_DISCHARGE", "TRANSPORTATION_LOUNGE", "Unknown", "VIDEO_VISIT", "VIDEO_VISIT_WAITING_ROOM", "WAITING"]
};

export const isMetricCount = (metricName: string) => {
    if (metricName === MetricName.ActivePatients || metricName === MetricName.ActiveBoarding || metricName === MetricName.ActiveAdmitRisk || metricName === MetricName.ActualAdmitRiskTP || metricName === MetricName.ActualAdmitRiskFP 
        || metricName === MetricName.ActualAdmitRiskAUROC || metricName === MetricName.RevisitScoreAUROC || metricName === MetricName.ActualArrived 
        || metricName === MetricName.ActualRoomed || metricName === MetricName.ActualDispo 
        || metricName === MetricName.ActualBoarded || metricName === MetricName.ActualDeparted
        || metricName === MetricName.ActiveBoardingMAE || metricName === MetricName.ActiveBedRequestsMAE
        || metricName === MetricName.ActiveRoomedNotDispoMAE || metricName === MetricName.ActualForecastPatientsMAE) {
        return true;
    } else {
        return false;
    }
}